<template>
  <div>
    <a :href="ogTags.url" target="_blank" @click="onOpen">
      <h5 v-if="ogTags.title" class="subtitle is-size-5">
        {{ ogTags.title }}
      </h5>

      <img v-if="ogTags.image" :src="ogTags.image" class="preview-image" />
    </a>

    <p v-if="ogTags.description">
      {{ ogTags.description }}
    </p>
  </div>
</template>

<script>
export default Vue.extend({
  props: {
    ogTags: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onOpen() {
      this.$emit("open");
    },
  },
});
</script>

<style scoped lang="sass">
.preview-image
    border-radius: 8px
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/views/news/app/EmbedCard.vue